export type UseCategoryGetParams = {
  pageContextType: CategoryPageContextTypes;
  currentContent: Ref<UserContent>;
  section: Ref<Sections>;
  slug: Ref<string>;
  baseCategory: CategorySchema;
  isStudyContent: boolean;
  isHome: boolean;
  load: () => Promise<void>;
};

export const useCategoryGetParamsStrategy = (
  pageContextType: CategoryPageContextTypes
): UseCategoryGetParams => {
  switch (pageContextType) {
    case CategoryPageContextTypes.AssessmentForm:
      return useCategoryGetParamsAssessmentForm(pageContextType);
    case CategoryPageContextTypes.AssessmentRun:
      return useCategoryGetParamsAssessmentRun(pageContextType);
    default:
      return useCategoryGetParamsFromRoute(pageContextType);
  }
};
